import { Theme } from './theme'

/**
 * Theme feature flags
 * Use these instead of checking theme names directly
 */
export interface ThemeFeatures {
  ticketDetailsBlueLayout: boolean
  loadingScreenTitle: boolean
  noResultLabelStyled: boolean
  yeekeeResultAlignment: boolean
  yeekeeShowResultsDivider: boolean
  showCurrencyIconInInput: boolean
  showBackLabel: boolean
  rulesHeaderPadding: boolean
  hideCurrencySymbolInBetControls: boolean
  spaceBetweenCurrencyAndNumberInBetControls: boolean
  useYeekeeModel: boolean
  ticketAlignLeft: boolean
  ticketGridColumns: number
}

/**
 * Base theme features for Gold themes
 */
const GOLD_FEATURES: ThemeFeatures = {
  loadingScreenTitle: false,
  ticketDetailsBlueLayout: false,
  noResultLabelStyled: false,
  yeekeeResultAlignment: false,
  yeekeeShowResultsDivider: false,
  showCurrencyIconInInput: false,
  showBackLabel: false,
  rulesHeaderPadding: false,
  hideCurrencySymbolInBetControls: false,
  spaceBetweenCurrencyAndNumberInBetControls: false,
  useYeekeeModel: false,
  ticketAlignLeft: false,
  ticketGridColumns: 1,
}

/**
 * Base theme features for Blue themes
 */
const BLUE_FEATURES: ThemeFeatures = {
  loadingScreenTitle: true,
  ticketDetailsBlueLayout: true,
  noResultLabelStyled: true,
  yeekeeResultAlignment: true,
  yeekeeShowResultsDivider: true,
  showCurrencyIconInInput: true,
  showBackLabel: true,
  rulesHeaderPadding: true,
  hideCurrencySymbolInBetControls: true,
  spaceBetweenCurrencyAndNumberInBetControls: true,
  useYeekeeModel: true,
  ticketAlignLeft: true,
  ticketGridColumns: 2,
}

/**
 * Theme feature configuration
 */
export const THEME_FEATURES: Record<Theme, ThemeFeatures> = {
  // Gold themes
  [Theme.GOLD_LIGHT]: { ...GOLD_FEATURES },
  [Theme.GOLD_DARK]: { ...GOLD_FEATURES },

  // Blue themes
  [Theme.BLUE_LIGHT]: { ...BLUE_FEATURES },
  [Theme.BLUE_DARK]: { ...BLUE_FEATURES },
}

/**
 * Get theme features for a given theme
 */
export function getThemeFeatures(theme: Theme): ThemeFeatures {
  return THEME_FEATURES[theme]
}
